<article class="group relative flex flex-col overflow-hidden bg-white w-full item-list-border-helper">
  <div class="flex flex-col items-center justify-center pb-8 md:pb-0 w-full group-hover:bg-opacity-5 group-hover:bg-primary-600">
    <div class="justify-between py-4 px-8 max-w-128">
      <div>
        <div class="h-64 flex flex-col items-center justify-center">
          <picture
            [bbitPictureSrc]="item().images?.length > 0 ? item().images[0] : '/assets/images/placeholder-image.png'"
            [bbitPictureDefaultSize]="260"
            [bbitPictureImgClasses]="'object-scale-down object-center'"
            [bbitPictureAlt]="item().designation | bbitAlgoliaI18n"
            [bbitPictureAspectRatio]="'4/3'"
            [bbitPictureWidth]="260"
            [bbitPictureHeight]="195"
          ></picture>
        </div>
        <div class="flex flex-1 flex-col space-y-2 mt-6 h-16">
          <h3 class="text-sm text-gray-800">
            <a (click)="registerItemClick()" [routerLink]="['/', 'shop', 'item', item()._slug ? item()._slug : item().objectID]">
              <span aria-hidden="true" class="absolute inset-0"></span>
              {{ item().designation | bbitAlgoliaI18n }}
            </a>
          </h3>
          <span class="text-xs text-gray-500">{{ item().itemNumber }}</span>
        </div>
      </div>

      <div class="flex flex-row w-full items-end justify-between mt-2 flex-1 h-12">
        @if (!website.isAuthenticated()) {
          <app-item-stock [stock]="item().stock" [hideText]="true" [doNotShowLoadingSpinner]="true"></app-item-stock>
          <div class="text-right">
            <app-item-price [price]="item().price"></app-item-price>
          </div>
        } @else {
          <app-item-stock [item]="item().objectID" [hideText]="true" [doNotShowLoadingSpinner]="true"></app-item-stock>
          <div class="text-right">
            <app-item-price [item]="item().objectID"></app-item-price>
          </div>
        }
      </div>
    </div>
  </div>
</article>
